const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M18 18H6V6h12v12Z\"/>"
};
exports.__esModule = true;
exports.default = data;
